<ion-list mode="ios" lines="none" class="list-content">
  <!-- * Descripción -->
  <ion-item
    mode="md"
    lines="none"
    color="white"
    class="ion-text-center item-texts"
  >
    <ion-label mode="md" color="status-icon-enable" class="body">
      <p class="mpe-font-weight-600 responsable">{{ responsable | async }}</p>
      {{ body }}
    </ion-label>
  </ion-item>

  <!-- * Icono -->
  <ion-item mode="md" lines="none" color="white">
    <ion-img
      [src]="'Icons.result-execution' | translate"
      class="result-execution"
    ></ion-img>
  </ion-item>

  <!-- * Botones -->
  <ion-item mode="md" lines="none" color="white">
    <ion-button
      class="button-center-results"
      size="default"
      mode="md"
      color="darkblue"
      (click)="onClose(true)"
    >
      <ion-label mode="md"> {{ 'Buttons.see-results' | translate }} </ion-label>
    </ion-button>
  </ion-item>

  <ion-item mode="md" lines="none" color="white">
    <ion-button
      class="mpe-button-link-line button-center-not"
      size="default"
      mode="md"
      fill="clear"
      color="darkblue"
      (click)="onClose(false)"
    >
      <ion-label mode="md"> {{ 'Buttons.not-now' | translate }} </ion-label>
    </ion-button>
  </ion-item>
</ion-list>
